module.exports = __webpack_public_path__ + "media/images/socials/linkedin-784a8a6874e21e79ae105d1d61a73daa.png";